export type ScheduleSort = 'ETD real' | 'ETA real' | 'Atraso';

export interface Transshipment {
  secondVessel: string;
  hubCode: string;
  hubFlag: string;
  hubName: string;
  hubShortName: string;
  firstLegEnd: number;
  secondLegStart: number;
}

export interface ScheduledVessel {
  vessel: string;
  carrier: string;
  pod: 'SHA' | 'HKG' | 'PHL' | 'NSA';
  originalEtd: number;
  realEtd: number;
  originalEta: number;
  actualEta: number;
  shipmentCount: number;
  transshipment?: Transshipment;
}

export const PORTS = {
  SHA: { name: 'Shanghái, CN (CNSHA)', flag: '🇨🇳' },
  HKG: { name: 'Hong Kong, HK (HKHKG)', flag: '🇭🇰' },
  PHL: { name: 'Philadelphia, US (USPHL)', flag: '🇺🇸' },
  NSA: { name: 'Nhava Sheva, IN (INNSA)', flag: '🇮🇳' },
} as const;

export const CARRIER_COLORS: Record<string, string> = {
  Maersk: '#3B82F6',
  MSC: '#F5A524',
  OOCL: '#BE123C',
  ONE: '#F871A0',
  PIL: '#8B5CF6',
  Evergreen: '#17C964',
  'CMA CGM': '#06B6D4',
  'Hede Shipping': '#A1A1AA',
};

export const SCHEDULED_VESSELS: ScheduledVessel[] = [
  {
    vessel: 'ONE COLUMBA',
    carrier: 'ONE',
    pod: 'HKG',
    originalEtd: -42,
    realEtd: -42,
    originalEta: -18,
    actualEta: -18,
    shipmentCount: 5,
  },
  {
    vessel: 'MAERSK ANTARES',
    carrier: 'Maersk',
    pod: 'SHA',
    originalEtd: -32,
    realEtd: -31,
    originalEta: -2,
    actualEta: 0,
    shipmentCount: 8,
  },
  {
    vessel: 'MSC LORETO',
    carrier: 'MSC',
    pod: 'SHA',
    originalEtd: -25,
    realEtd: -25,
    originalEta: 2,
    actualEta: 2,
    shipmentCount: 5,
  },
  {
    vessel: 'OOCL CHILE',
    carrier: 'OOCL',
    pod: 'HKG',
    originalEtd: -24,
    realEtd: -22,
    originalEta: 1,
    actualEta: 3,
    shipmentCount: 4,
  },
  {
    vessel: 'HSL NIKE',
    carrier: 'Hede Shipping',
    pod: 'PHL',
    originalEtd: -20,
    realEtd: -19,
    originalEta: -1,
    actualEta: 1,
    shipmentCount: 2,
  },
  {
    vessel: 'KOTA PLUMBAGO',
    carrier: 'PIL',
    pod: 'NSA',
    originalEtd: -22,
    realEtd: -18,
    originalEta: 2,
    actualEta: 6,
    shipmentCount: 3,
    transshipment: {
      secondVessel: 'X-PRESS SALWEEN',
      hubCode: 'SIN',
      hubFlag: '🇸🇬',
      hubName: 'Singapur (SGSIN)',
      hubShortName: 'Singapur',
      firstLegEnd: -6,
      secondLegStart: -3,
    },
  },
  {
    vessel: 'EVER OUTDO',
    carrier: 'Evergreen',
    pod: 'HKG',
    originalEtd: -15,
    realEtd: -15,
    originalEta: 7,
    actualEta: 7,
    shipmentCount: 6,
  },
  {
    vessel: 'CMA CGM TANGER',
    carrier: 'CMA CGM',
    pod: 'SHA',
    originalEtd: -10,
    realEtd: -9,
    originalEta: 9,
    actualEta: 9,
    shipmentCount: 7,
  },
  {
    vessel: 'KOTA SALAM',
    carrier: 'PIL',
    pod: 'NSA',
    originalEtd: -7,
    realEtd: -6,
    originalEta: 13,
    actualEta: 14,
    shipmentCount: 3,
    transshipment: {
      secondVessel: 'KOTA RUKUN',
      hubCode: 'SIN',
      hubFlag: '🇸🇬',
      hubName: 'Singapur (SGSIN)',
      hubShortName: 'Singapur',
      firstLegEnd: 4,
      secondLegStart: 6,
    },
  },
  {
    vessel: 'MAERSK LOTA',
    carrier: 'Maersk',
    pod: 'PHL',
    originalEtd: 2,
    realEtd: 2,
    originalEta: 16,
    actualEta: 16,
    shipmentCount: 4,
  },
];
